
import consultation from '/assets/images/blog/consultation.png';

const categories = [
  {
    title: "consultation",
    icon: '/assets/images/blog/consultation.png',
    color: "bg-green-text",
  },
  {
    title: "Health Technology",
    icon: '/assets/images/blog/lab_panel_27dp_FFFF_FILL0_wght400_GRAD0_opsz24.png',
    color: "bg-blue-primary",
  },
  {
    title: "Public Health and prevention",
    icon: '/assets/images/blog/fluid_med_24dp_FFFF_FILL0_wght400_GRAD0_opsz24.png',
    color: "bg-green-text",
  },
  {
    title: "Nutrition, sport and other",
    icon: '/assets/images/blog/rib_cage_24dp_FFFF_FILL0_wght400_GRAD0_opsz24.png',
    color: "bg-blue-primary",
  },
]

export function CategoryCards() {
  return (
    <section className="max-w-6xl mx-auto px-4 -mt-20 relative z-20">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {categories.map((category, index) => (
          <div
            key={index}
            className={`${category.color} p-6 rounded-lg text-white text-center cursor-pointer transition-transform hover:scale-105`}
          >
            <img src={category.icon} alt={category.title} className="h-12 w-12 mx-auto mb-4" />
            <h3 className="font-semibold">{category.title}</h3>
          </div>
        ))}
      </div>
    </section>
  )
}

